<style>
  .stepContainer {
    background-color: #F2F2F2;
    padding: 10px;
    border-radius: 5px;
  }

  .codeMirrorContainer {
    height: 650px;
    margin-top: 20px
  }

  .fullScreenCodeMirrorContainer {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 999;
  }

  .codeMirrorContainer .CodeMirror,
  .fullScreenCodeMirrorContainer .CodeMirror {
    height: 100%;
  }

  .closeFullEdit {
    position: fixed;
    right: 20px;
    top: 10px;
    z-index: 10000;
    border: 0px;
    background-color: #ffffff1d;
  }
</style>
<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div>
    <el-row :gutter="15" style="margin-top: 20px;">
      <el-col :span="18">
        <div class="grid-content stepContainer">
          <div>
            编辑脚本内容：
            <span style="float: right">
              <el-link icon="el-icon-full-screen" @click="fullScreen" style="margin-left:5px" title="开启全屏编辑模式">全屏编辑
              </el-link>
            </span>
          </div>
          <div :class="{ codeMirrorContainer:!isFullScreen,fullScreenCodeMirrorContainer:isFullScreen}">
            <el-button v-if="isFullScreen" class="closeFullEdit" @click="closeFullScreen" icon="el-icon-close"
              title="退出全屏">退出全屏</el-button>
            <div class="in-coder-panel" style="height: 100%">
              <textarea ref="textarea"></textarea>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content stepContainer">
          <div>
            请选择脚本调试方法：
          </div>
          <el-select style="width:100%" v-model="funName" placeholder="请选择脚本调试方法">
            <el-option v-for="item in funList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
          <div style="margin-top: 20px">
            填写消息参数：
          </div>
          <div style="background-color: white;margin-top: 15px;padding: 5px">
            <p>数据内容(16进制字符串)：</p>
            <el-input style="margin:8px 0px;width: 100%" :rows="4" type="textarea" v-model="paramsJson.source_data"
              placeholder="请输入数据内容"></el-input>
            <el-checkbox v-model="paramsJson.moduleCode.haveModuleCode" style="width: 30%">网关编号：</el-checkbox>
            <el-input size="small" v-model="paramsJson.moduleCode.value" style="width: 60%"
              v-if="paramsJson.moduleCode.haveModuleCode" placeholder="网关编号"></el-input></br>

            <el-checkbox v-model="paramsJson.deviceCode.haveDeviceCode" style="width: 30%">设备编号：</el-checkbox>
            <el-input size="small" v-model="paramsJson.deviceCode.value" style="width: 60%"
              v-if="paramsJson.deviceCode.haveDeviceCode" placeholder="设备编号"></el-input></br>

            <el-checkbox v-model="paramsJson.serviceCode.haveServiceCode" style="width: 30%">服务编号：</el-checkbox>
            <el-input size="small" v-model="paramsJson.serviceCode.value" style="width: 60%"
              v-if="paramsJson.serviceCode.haveServiceCode" placeholder="网关编号"></el-input></br>

            <div style="margin-top:8px">
              <el-checkbox v-model="paramsJson.fields.haveOptions">其他参数:</el-checkbox>
              <i class="el-icon-circle-plus-outline" v-if="paramsJson.fields.haveOptions" @click="addOptions"
                title="新增参数"></i>
              <div style="margin-top:4px" v-for="item in paramsJson.fields.value" v-if="paramsJson.fields.haveOptions"
                :key="item.index">
                <el-input size="small" v-model="item.key" style="width:30%" placeholder="key"></el-input>
                <el-input size="small" v-model="item.data" style="width:30%;margin: 0px 10px" placeholder="value">
                </el-input>
                <el-button size="small" icon="el-icon-delete" circle @click="delOptions(item.index)" title="删除该参数">
                </el-button>
              </div>
            </div>
          </div>
          <div style="text-align: center;margin-top: 10px">
            <el-button type="primary" round @click="debugScript"
              :disabled="scriptContent==''||funName==''||paramsJson.source_data==''">调试脚本</el-button>
          </div>
        </div>

        <div class="grid-content stepContainer" style="margin-top:20px">
          <div>
            解析结果
            <span style="float: right">
              <el-link icon="el-icon-document-delete" @click="clearLogList" style="margin-left:5px">清空日志</el-link>
            </span>
          </div>
          <div style="margin-top: 15px;height:250px;overflow-y: scroll;">
            <div v-for="(item,index) in logList" :key="index">
              <div v-if="item=='analysisSuccess'" style="color:#A5C261">
                解析成功
              </div>
              <div v-if="item=='analysisFail'" style="color:#DA775F">
                解析失败
              </div>
              <pre v-if="item!=='analysisSuccess'&&item!=='analysisFail'">{{item}}</pre>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import API from "../api/api";
  import dayjs from "dayjs"
  // 引入全局实例
  import _CodeMirror from 'codemirror'

  // 核心样式
  import 'codemirror/lib/codemirror.css'
  // 引入主题后还需要在 options 中指定主题才会生效
  import 'codemirror/theme/monokai.css'

  // 需要引入具体的语法高亮库才会有对应的语法高亮效果
  // codemirror 官方其实支持通过 /addon/mode/loadmode.js 和 /mode/meta.js 来实现动态加载对应语法高亮库
  // 但 vue 貌似没有无法在实例初始化后再动态加载对应 JS ，所以此处才把对应的 JS 提前引入
  import 'codemirror/mode/javascript/javascript.js'
  import 'codemirror/mode/css/css.js'
  import 'codemirror/mode/xml/xml.js'
  import 'codemirror/mode/clike/clike.js'
  import 'codemirror/mode/markdown/markdown.js'
  import 'codemirror/mode/python/python.js'
  import 'codemirror/mode/r/r.js'
  import 'codemirror/mode/shell/shell.js'
  import 'codemirror/mode/sql/sql.js'
  import 'codemirror/mode/swift/swift.js'
  import 'codemirror/mode/vue/vue.js'
  import 'codemirror/mode/groovy/groovy.js'

  //代码折叠
  import "codemirror/addon/fold/foldgutter.css"
  import "codemirror/addon/fold/foldcode"
  import "codemirror/addon/fold/foldgutter"
  import "codemirror/addon/fold/brace-fold"
  import "codemirror/addon/fold/comment-fold"

  import "codemirror/addon/selection/active-line" //光标所在行高亮

  // 尝试获取全局实例
  const CodeMirror = window.CodeMirror || _CodeMirror

  export default {
    name: 'script-debug-component',
    props: {
      // 外部传入的内容，用于实现双向绑定
      script: String,
      initVal: String,
    },
    data() {
      return {
        scriptContent: '', //内部真实脚本内容
        paramsJson: { //消息内容
          source_data: '', //内容
          moduleCode: { //网关编号
            haveModuleCode: false,
            value: '',
          },
          deviceCode: { //设备编号
            haveDeviceCode: false,
            value: '',
          },
          serviceCode: { //服务编号
            haveServiceCode: false,
            value: '',
          },
          fields: { //其他参数
            haveOptions: false,
            value: [{
              index: 0,
              key: '',
              data: ''
            }]
          }
        },

        funList: [ //脚本调试方法列表
          {
            value: 'analysis',
            name: '上行解码'
          },
          {
            value: 'assembleDownCmd',
            name: '下行编码'
          },
        ],
        funName: 'analysis', //选中的脚本调试方法
        logList: [], //调试日志
        isFullScreen: false, //是否开启全屏编辑

        // 默认的语法类型
        mode: 'x-groovy',
        // 编辑器实例
        coder: null,
        // 默认配置
        options: {
          // 缩进格式
          tabSize: 2,
          // 主题，对应主题库 JS 需要提前引入
          theme: 'monokai', // 主题，对应主题库 JS 需要提前引入 monokai,dracula
          // 显示行号
          lineNumbers: true,
          line: true,
          lineWrapping: true, //代码折叠
          foldGutter: true, //启用行槽中的代码折叠
          gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"],
        },

      }
    },
    created() { },
    watch: {
      initVal(newVal, oldVal) {
        this.coder.setValue(newVal)
      }
    },
    methods: {
      // 初始化
      _initialize() {
        // 初始化编辑器实例，传入需要被实例化的文本域对象和默认配置
        this.coder = CodeMirror.fromTextArea(this.$refs.textarea, this.options)
        // 编辑器赋值
        this.coder.setValue(this.script || this.scriptContent)

        // 支持双向绑定
        this.coder.on('change', (coder) => {
          this.scriptContent = coder.getValue()
          if (this.$emit) {
            this.$emit('changeScript', this.scriptContent)
          }
        })
      },
      /***********************调试接口************************/

      //发送报文
      debugScript() {
        if (this.scriptContent == '' || this.funName == '' || this.paramsJson.source_data == '') {
          this.$message.warning("请填写完脚本调试参数")
          return false
        }
        var json = {
          source_data: this.paramsJson.source_data
        }
        if (this.paramsJson.moduleCode.haveModuleCode) {
          json.module_code = this.paramsJson.moduleCode.value
        }
        if (this.paramsJson.deviceCode.haveDeviceCode) {
          json.device_code = this.paramsJson.deviceCode.value
        }
        if (this.paramsJson.serviceCode.haveServiceCode) {
          json.packet_code = this.paramsJson.serviceCode.value
        }
        var optionsValue = this.paramsJson.fields.value
        if (this.paramsJson.fields.haveOptions) {
          var options = {}
          for (let j = 0; j < optionsValue.length; j++) {
            if (optionsValue[j].key != '' && optionsValue[j].data != '')
              options[optionsValue[j].key] = optionsValue[j].data;
          }
          json.options = options
        }
        let para = {
          scriptContent: this.scriptContent,
          funName: this.funName,
          paramsJsonStr: JSON.stringify(json)
        }
        API.groovyDebug(para)
          .then(res => {
            this.logList = [];
            if (res.code == 1) { //解析成功
              this.logList.push("analysisSuccess")
              this.logList.push(res.data)
            } else { //解析失败
              this.logList.push("analysisFail")
              this.logList = this.logList.concat(res.msg)
            }
          })
      },
      /*****************************按钮功能******************************/
      //全屏编辑
      fullScreen() {
        this.isFullScreen = true
        this.$message("全屏模式，按【ESC】键退出");
      },
      //退出全屏编辑
      closeFullScreen(event) {
        if ((event.key == "Escape" && this.isFullScreen == true) || !(event.key)) {
          this.isFullScreen = false
        }
      },
      //增加其他参数
      addOptions() {
        var index = 0
        if (this.paramsJson.fields.value.length > 0) {
          index = this.paramsJson.fields.value[this.paramsJson.fields.value.length - 1].index + 1
        }
        var json = {
          index: index,
          key: '',
          data: ''
        }
        this.paramsJson.fields.value.push(json)
      },
      //删除其他参数
      delOptions(index) {
        for (let i = 0; i < this.paramsJson.fields.value.length; i++) {
          if (this.paramsJson.fields.value[i].index == index) {
            this.paramsJson.fields.value.splice(i, 1);
            break;
          }
        }
      },
      //清空日志
      clearLogList() {
        this.logList = [];
      },
    },
    mounted() {
      // 初始化
      this.scriptContent = this.initVal
      this._initialize()
      this.$emit('changeScript', this.scriptContent)
      window.addEventListener('keyup', this.closeFullScreen)
    },
  }

</script>


// WEBPACK FOOTER //
// src/components/scriptDebugComponent.vue